//own imports
import LoadingGif from '../../../images/LoadingGif.gif';
import './Groups.css';
// react imports
import React, {
    useEffect,
    useState
} from 'react';
import { Link } from "react-router-dom";
import { Fab } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import * as FaIcons from 'react-icons/fa';

//firebase
import { collection, query, where, getDocs } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import {
    initializeApp
} from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBqU42lAjLn0NUdTEwAexRmyt3Bs333g0I",
    authDomain: "expensor-78ad1.firebaseapp.com",
    projectId: "expensor-78ad1",
    storageBucket: "expensor-78ad1.appspot.com",
    messagingSenderId: "685316790253",
    appId: "1:685316790253:web:79dcd75c79f9197fe439e4",
    measurementId: "G-LC26DDDV3H"
};

// Initialize Firebase
// eslint-disable-next-line no-unused-vars
const app = initializeApp(firebaseConfig);
const db = getFirestore();
const auth = getAuth();

const Groups = () => {

    const [loadingGroups, setLoading] = useState(true);
    const [groups, setGoups] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    
    useEffect(() => {

        onAuthStateChanged(auth, (user) => {
            if (user !== null) {
                setCurrentUser(user);
                getPersonGroups(user.uid);
            }
        });
        
        document.title = "Groups";
        if (currentUser === null || currentUser === undefined) {
            getCurrentUser();
        }

        else{
            setGoups([]);
            setLoading(false);
        }

        // return cleanup function
        return () => query();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // empty dependencies array => useEffect will only be called once.

    if (loadingGroups) {
        return(
            <div style={{minHeight: '100vh'}}>
                <h1 className="header">Groups</h1>
                <img className='loaderGif' src={LoadingGif} alt="Loading" />
                <p className="">Loading your groups...</p>
                <p className='errorMessage'></p>
            </div>
        );
    }
    else{
        return (
            <div style={{ minHeight: '100vh', overflow: 'scroll' }}>
                <h1 className="header">Groups</h1>
                <div className="groupBox">
                    {groups.length > 0 ? (groups.map((group => <Link to={"/expenses/" + group.key}  style={{backgroundColor : group.color}} className="groupItem" key={group.key}>{group.name}</Link>))) : <h1 className="header">No groups available</h1>}
                </div>
                <Link to="/createEditGroup/null"><Fab style={{ bottom: 12, right: 12, }} icon={<FaIcons.FaPlus></FaIcons.FaPlus>} mainButtonStyles={{ backgroundColor: '#027B93'}} text="Add Group"></Fab></Link>
                <p className='errorMessage'></p>
            </div>
        );
    }

    async function getPersonGroups(uid) {



       try{
           const getGroupsFromFirebase = [];

           const q = query(collection(db, "Groups"), where("members", "array-contains", uid), where("isDeleted", "==", false));

           //vragen docent const q2 = query(collection)

           const querySnapshot = await getDocs(q);
           querySnapshot.forEach((doc) => {
               // doc.data() is never undefined for query doc snapshots
               getGroupsFromFirebase.push({ ...doc.data(), key: doc.id }); // ... => spreidinsoperator
           });


           setGoups(getGroupsFromFirebase);
           setLoading(false);
       }catch(error){
           const errorMessage = document.querySelector('.errorMessage');
           errorMessage.innerHTML = "Problem retrieving  your groups: " +error;
           try {
               document.getElementsByClassName('loaderGif')[0].style.display = 'none';
           } catch (error) {
               
           }
       }
    }

    function getCurrentUser() {
        if (auth.currentUser !== null) {
            setCurrentUser(auth.currentUser);
            getPersonGroups(auth.currentUser.uid);
        }
    }
};

export default Groups;